module.exports = __webpack_public_path__ + "img/stop_btn.2a10a340.png";